import useOptimisticCreateCustomFieldGroup from '@/api/mutations/account/optimistic/useOptimisticCreateCustomFieldGroup';
import useGetMyCustomFieldGroups from '@/api/queries/me/useGetMyCustomFieldGroups';

import { FC, useEffect, useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { CustomFieldGroupControl } from '../customFieldGroupControl/CustomFieldGroupControl';

export const CompanySettingsCustomerCustomFields: FC = () => {
  const { data: customFieldGroups } = useGetMyCustomFieldGroups();

  const customerCustomFieldGroup = useMemo(
    () => customFieldGroups?.find((x) => x.role === 'customer'),
    [customFieldGroups]
  );

  const { mutateAsync: createCustomFieldGroup } =
    useOptimisticCreateCustomFieldGroup();

  useEffect(() => {
    if (
      customFieldGroups &&
      !customFieldGroups.find((x) => x.role === 'customer')
    ) {
      void createCustomFieldGroup({
        role: 'customer',
        id: uuid(),
      });
    }
  // oxlint-disable-next-line eslint-plugin-react-hooks(exhaustive-deps) -- FIXME: pre-existing error: React Hook useEffect has a missing dependency: 'createCustomFieldGroup'
  }, [customFieldGroups]);

  if (!customerCustomFieldGroup) {
    return null;
  }

  return (
    <CustomFieldGroupControl
      customFieldGroup={customerCustomFieldGroup}
      heading="Customer Custom Fieldsets"
      subHeading="Once created Custom Fieldsets can be set on each Customer."
    />
  );
};
